import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import InfoRow from './infoRow.js';
const formatDateTime = (iso, locale) => {
    const dt = DateTime.fromISO(iso);
    if (!dt.isValid)
        return iso;
    return locale === 'fi'
        ? dt.toFormat('dd.MM.yyyy HH:mm')
        : dt.toFormat('MM/dd/yyyy HH:mm');
};
const ContactPersonCard = ({ contactPerson, strongAuthCompleted, }) => {
    var _a;
    const { t, i18n } = useTranslation();
    const showStrongAuth = strongAuthCompleted && contactPerson.strongAuthName !== null;
    return (_jsxs(Paper, { variant: "outlined", sx: { p: 3, height: '100%' }, children: [_jsx(Typography, { variant: "subtitle1", sx: { fontWeight: 700, mb: 2 }, children: t('applicationDetail.contactPerson') }), _jsx(InfoRow, { label: t('applicationDetail.name'), value: contactPerson.name }), _jsx(InfoRow, { label: t('applicationDetail.email'), value: _jsx(Link, { href: `mailto:${contactPerson.email}`, underline: "hover", children: contactPerson.email }) }), _jsx(InfoRow, { label: t('applicationDetail.phone'), value: _jsx(Link, { href: `tel:${contactPerson.phone}`, underline: "hover", children: contactPerson.phone }) }), showStrongAuth && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(Divider, { sx: { mb: 2 } }), _jsx(Typography, { variant: "body2", sx: { fontWeight: 600, mb: 1 }, children: t('applicationDetail.strongAuthSection') }), _jsx(InfoRow, { label: t('applicationDetail.strongAuthName'), value: (_a = contactPerson.strongAuthName) !== null && _a !== void 0 ? _a : '' }), contactPerson.strongAuthAt && (_jsx(InfoRow, { label: t('applicationDetail.strongAuthAt'), value: formatDateTime(contactPerson.strongAuthAt, i18n.language) }))] }))] }));
};
export default ContactPersonCard;
